import { QueryClient as e } from "@tanstack/react-query";
import t from "deepmerge";
//#region src/api.constants.ts
var n = 300 * 1e3, r = { defaultOptions: { queries: {
	gcTime: n,
	refetchOnWindowFocus: !1
} } }, i = (n) => new e(t(r, n ?? {}));
//#endregion
export { n, i as t };

//# sourceMappingURL=createApiQueryClient-DwmsEdyU.js.map